import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import app from '../../../plugins/routes/app';
import { connect } from 'react-redux';

import List from "./TripApproval/TripApprovalList"

class TripApproval extends Component {

    render() {
        let tripapprovals = app.routes.find(x => x.name === 'tripapprovals');
        return (
            <Fragment>
                <Switch>
                    <Route exact path="/app/tripapprovals" component={List} />
                    {tripapprovals.routes.map((route, key) => {
                        return <Route
                            path={`${app.path}${tripapprovals.path}${route.path}`}
                            meta={route.meta}
                            component={route.component}
                            key={key}
                        />;
                    })}
                </Switch>
            </Fragment>

        )
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripApproval);


// WEBPACK FOOTER //
// ./src/components/App/Views/TripApproval.js